import NavigationService from "@ane/core/lib/services/NavigationService";
import { showMigrationBannerOnRedirect, showWorkspaceSelectionTeachingBubbleOnRedirect } from "./WorkspaceMigrationData.utils.js";
import { setUserAffinity } from "../../userDetails/GetUserAffinity.utils.js";
import { GROUP_ID, MANAGEMENT_GROUP } from "@ane/core/lib/constants/QueryString.constants";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import Logger from "@ane/core/lib/services/logging/Logger";
import { WorkspaceMigrationTelemetryEventNames } from "../../telemetry/WorkspaceMigrationTelemetryEventNames.js";
const workspaceMigrationNavigate = (payload) => {
  var _a, _b;
  const { url, workspaceId, experimentationGroupPath = "", isMigrationRevertRedirect = false } = payload;
  if (!isMigrationRevertRedirect) {
    showMigrationBannerOnRedirect(workspaceId);
    showWorkspaceSelectionTeachingBubbleOnRedirect();
  }
  setUserAffinity(workspaceId, experimentationGroupPath);
  let href = `${url}`;
  let searchString = (_b = (_a = new URL(href)) == null ? void 0 : _a.search) != null ? _b : "";
  const searchParams = new URLSearchParams(searchString);
  const hasGroup = searchParams.has(GROUP_ID);
  const hasManagementGroup = searchParams.has(MANAGEMENT_GROUP);
  if (hasGroup) {
    searchString = NavigationService.omitQueryParams([GROUP_ID], searchString);
    href = NavigationService.addParamToHref({
      href: `${WindowLocation.origin}${WindowLocation.pathname}${searchString}${WindowLocation.hash}`,
      param: GROUP_ID,
      value: experimentationGroupPath
    });
  }
  if (hasManagementGroup) {
    searchString = NavigationService.omitQueryParams([MANAGEMENT_GROUP], searchString);
    href = NavigationService.addParamToHref({
      href: `${WindowLocation.origin}${WindowLocation.pathname}${searchString}${WindowLocation.hash}`,
      param: MANAGEMENT_GROUP,
      value: experimentationGroupPath
    });
  }
  Logger.trackEvent({
    name: WorkspaceMigrationTelemetryEventNames.WSMigration_WorkspaceMigrationRedirect_url,
    properties: {
      currentURL: WindowLocation.href,
      redirectURL: url,
      redirectWorkspaceId: workspaceId,
      redirectExperimentationGroupId: experimentationGroupPath,
      redirectTo: href,
      isMigrationRevertRedirect
    },
    measurements: {}
  });
  NavigationService.openExternalLinkInCurrentTab(href);
};
export {
  workspaceMigrationNavigate
};
//# sourceMappingURL=WorkspaceMigration.utils.js.map
